import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import session     from './modules/session'
import users       from './modules/users'
import banks       from './modules/banks'
import customers   from './modules/customers'
import assessments from './modules/assessments'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    users,
    banks,
    customers,
    assessments
  }
})
